<template>
  <v-container
    fluid
  >
    <v-row
      v-for="targetId in targetsId"
      :key="targetId"
      align="stretch"
    >
      <v-col
        v-for="targetDevice in targetDevices.filter(e => e.groupCode === targetId)"
        :key="targetDevice.id"
        cols="12"
        md="3"
        sm="4"
        lg="2"
      >
        <div v-if="targetDevice.type == 'Temp'">
          <temperature-mini-state-view
            :target-device-id="targetDevice.id"
            :target-device-code="targetDevice.code"
          />
        </div>
        <div v-else>
          <tank-mini-state-view
            :target-device-id="targetDevice.id"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.v-toolbar__title{
  color: white;
}
</style>
<script>
  // import filters from '@/common/filters'
  import TemperatureMiniStateView from '@/views/dashboard/components/temperature/TemperatureMiniStateView'
  import TankMiniStateView from '@/views/dashboard/components/tanks/TankMiniStateView'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const targetdDevicesRespository = repositoryFactory.get('targetdDevices')

  export default {
    components: { TemperatureMiniStateView, TankMiniStateView },
    data () {
      return {
        targetDevices: [],
        targetsId: [],
      }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        var self = this
        targetdDevicesRespository.getActives().then(response => {
          self.targetDevices = response.data.data
          self.targetDevices.forEach((element) => {
            if (!self.targetsId.some(e => e === element.groupCode)) {
              self.targetsId.push(element.groupCode)
            }
          })
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
    },
  }
</script>

<style lang="sass">

</style>
